module.exports = __webpack_public_path__ + "img/logo-white.727025cb.png";